let config = null;
const timestamp = new Date().getTime();
const configUrl = window.location.origin + '/basic-auth/config/config.json?version=' + timestamp;
const request = new XMLHttpRequest();
request.open('GET', configUrl, false);
request.send(null);
config = JSON.parse(request.responseText);

export const environment = {
  ...config
}
